import React from "react";
import { FaTimes } from "react-icons/fa";
import ButtonPrimary from "../../Components/subcomponents/ButtonPrimary";

const BallotModal = ({ isOpen, onClose, data, onSubmit, onComplete }) => {
  // Hooks must run unconditionally, so the early return comes after them.
  const [page, setPage] = React.useState(0);
  const [submitting, setSubmitting] = React.useState(false);

  if (!isOpen) return null;

  // Submit happens here, on the review page — the "Ballot Submitted" page is
  // only shown once the server has actually accepted the ballot.
  const handleSubmit = async () => {
    if (submitting) return; // Guard against double-taps creating duplicate ballots
    setSubmitting(true);
    try {
      const ok = await onSubmit();
      if (ok) setPage(1);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-w-md w-full">
        {page == 0 && (
          <div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Review Your Ballot</h2>
              <button
                onClick={onClose}
                className="text-gray-700 hover:text-gray-900 focus:outline-none"
              >
                <FaTimes />
              </button>
            </div>
            <div className="mb-4">
              {Object.entries(data).map(([key, value]) => (
                key !== "comments" ? (
                  <div key={key} className="flex justify-between py-2">
                    <span className="font-semibold">{key}</span>
                    <span>{value} / 25</span>
                  </div>
                ) : (
                  <div key={key} className="py-2">
                    <span className="font-semibold">{key}:</span>
                    <p>{value}</p>
                  </div>
                )
              ))}
            </div>
            <div className="flex justify-between">
              <ButtonPrimary
                label="Go Back"
                onClick={onClose}
              />
              <ButtonPrimary
                label={submitting ? "Submitting…" : "Submit"}
                disabled={submitting}
                onClick={handleSubmit}
              />
            </div>
          </div>
        )}

        {page == 1 && (
          <div>
            <div className="text-center">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-2xl font-bold">Ballot Submitted</h2>
                <button
                  onClick={onComplete}
                  className="text-gray-700 hover:text-gray-900 focus:outline-none"
                >
                  <FaTimes />
                </button>
              </div>
              <div className="mb-6">
                <p className="text-lg mb-4">Thank you for submitting your ballot!</p>
                <p className="text-md font-semibold text-blue-600">
                  Please remember to place your sticker on the dash card.
                </p>
              </div>
              <ButtonPrimary
                label="Close"
                onClick={onComplete}
              />
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default BallotModal;
